import dayjs from 'dayjs';

export const formatDay = (date: Date | string | number) => {
  return new Date(date).toLocaleDateString();
};

export const formatDate = (value: Date | string | number) => {
  const date = new Date(value);
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
};

export const parseDate = (value: Date | string) => {
  let date = new Date(value);
  if (isNaN(date.getTime())) {
    return '';
  }
  return dayjs(date).format('YYYY-MM-DD');
};

export const getJoinedDate = (month: string, day: string, year: string): string => {
  const timestamp = Date.parse(`${month}/${day}/${year}`);
  if (!isNaN(timestamp)) {
    return parseDate(new Date(timestamp));
  } else {
    return '';
  }
};

export const isDateValid = (input: Date | string | number) => {
  const date = new Date(input);
  return (!isNaN(date.getFullYear()) && !isNaN(date.getMonth()) && !isNaN(date.getDate())) ? date : undefined;
};

/**
 * Expects the input to be in a format of a date string
 * not a datetime (I.E. 2/31/2020 or 2020-2-31) and returns
 * a US standard format date
 * @param input 
 * @returns
 */
export const convertToFormattedDate = (input: string | undefined) => {
  if (!input) return input;
  const date = isDateValid(input);
  if (date) {
    let month = `${date.getUTCMonth() + 1}`;
    if (month.length < 2) month = '0' + month;
    let day = `${date.getUTCDate()}`;
    if (day.length < 2) day = '0' + day;
    return `${month}/${day}/${date.getUTCFullYear()}`;
  }
  return "Invalid Date";
};

/**
 * Expects the input to be in a format of a date string
 * not a datetime (I.E. 2/31/2020 or 2020-2-31) and returns
 * a standard iso date in UTC
 * @param input 
 * @returns
 */
export const convertToIsoDate = (input: string | undefined) => {
  if (!input) return input;
  const date = isDateValid(input);
  if (date) {
    let month = `${date.getUTCMonth() + 1}`;
    if (month.length < 2) month = '0' + month;
    let day = `${date.getUTCDate()}`;
    if (day.length < 2) day = '0' + day;
    return `${date.getUTCFullYear()}-${month}-${day}`;
  }
  return input;
};